<div class="date-tab-content">
  <app-select
    label="Year"
    small
    [control]="yearControl"
    [options]="yearsOptions"
  ></app-select>

  <mat-tab-group
    animationDuration="0ms"
    class="tab-group"
    [selectedIndex]="selectedMonthIndex"
    (selectedTabChange)="setTabFilter($event)">
    <mat-tab *ngFor="let month of months" [label]="month"></mat-tab>
  </mat-tab-group>
</div>
